var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
    'dashboard-toast': true
  }, _obj[("toast-" + _vm.variant)] = true, _obj )},[_c('div',{staticClass:"toast-title"},[_vm._v("\n          "+_vm._s(_vm.$t('notification_toast.'+_vm.variant))+"\n\n          "),_c('img',{attrs:{"src":"/icons/toast-close.svg"},on:{"click":function($event){return _vm.$emit('close')}}})]),_c('p',{staticClass:"toast-text"},[_vm._v("\n          "+_vm._s(_vm.$t(("error_codes." + _vm.content)))+"\n      ")])])}
var staticRenderFns = []

export { render, staticRenderFns }